import React, {PureComponent} from 'react';
import {BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer} from 'recharts';
import {css} from "@emotion/css";


const SimpleBarChart = () => {
    return (
        <div className={css`width: 100%;
          height: 600px;`}>
            <ResponsiveContainer width="100%" height="100%" className={css`direction: ltr;`}>
                <BarChart
                    width={500}
                    height={300}
                    data={data}
                    margin={{
                        top: 5,
                        right: 30,
                        left: 20,
                        bottom: 5,
                    }}
                    barCategoryGap={'20%'} //DEFAULT: '10%'
                    barGap={'10'} //DEFAULT: 4
                    // barSize={'10000000'}
                    maxBarSize={'1000000'}
                    reverseStackOrder={true} //DEFAULT: false
                    fill="var(--color-purple)"
                >
                    <CartesianGrid strokeDasharray="3 3" fill="var(--color-on-surface)"/>
                    <XAxis
                        dataKey="name"
                        reversed={true}
                    />
                    <YAxis/>
                    <Tooltip/>
                    <Legend />
                    <Bar dataKey="firstReport" name={"گزارش اول"} fill="var(--color-purple)"/>
                    <Bar dataKey="secondReport" name={"گزارش دوم"} fill="var(--color-green)"/>
                    <Bar dataKey="thirdReport" name={"گزارش سوم"} fill="var(--color-red)"/>
                </BarChart>
            </ResponsiveContainer>
        </div>
    )
}
export default SimpleBarChart;
const data = [
    {
        name: 'شنبه',
        firstReport: 2400,
        secondReport: 4000,
        thirdReport: 400,
        amt: 2400,
    },
    {
        name: 'یکشنبه',
        firstReport: 1398,
        secondReport: 3000,
        thirdReport: 400,
        amt: 2210,
    },
    {
        name: 'دوشنبه',
        firstReport: 9800,
        secondReport: 2000,
        thirdReport: 400,
        amt: 2290,
    },
    {
        name: 'سه شنبه',
        firstReport: 3908,
        secondReport: 2780,
        thirdReport: 400,
        amt: 2000,
    },
    {
        name: 'چهارشنبه',
        firstReport: 4800,
        secondReport: 1890,
        thirdReport: 400,
        amt: 2181,
    },
    {
        name: 'پنجشنبه',
        firstReport: 3800,
        secondReport: 2390,
        thirdReport: 400,
        amt: 2500,
    },
    {
        name: 'جمعه',
        firstReport: 4300,
        secondReport: 3490,
        thirdReport: 400,
        amt: 2100,
    },
];